import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const ROUTES = {
  CUSTOMER_CONTACT_LIST: 'organization-customer-contact',
  CUSTOMER_CONTACT_INACTIVE_LIST: 'organization-customer-contact-inactive',
  CUSTOMER_CONTACT_CREATE: 'organization-customer-contact-create',
  CUSTOMER_CONTACT_DETAIL: 'organization-customer-contact-detail',
  CUSTOMER_CONTACT_DOCUMENT_LIST: 'organization-customer-documents'
}

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const listChildren = [
  {
    path: 'create/',
    name: ROUTES.CUSTOMER_CONTACT_CREATE,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_customercontact_create'],
      requiresAuth: true
    },
    component: () => import('./CustomerContactCreate.vue')
  },
  {
    path: ':cntId/',
    name: ROUTES.CUSTOMER_CONTACT_DETAIL,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_customercontact_retrieve'],
      requiresAuth: true
    },
    component: () => import('./CustomerContactDetail.vue'),
    children: [
      {
        path: 'documents/',
        name: ROUTES.CUSTOMER_CONTACT_DOCUMENT_LIST,
        beforeEnter: beforeEnter,
        props: true,
        meta: {
          permissions: ['document_uploaddocument_list'],
          requiresAuth: true
        },
        component: () => import('../../../../document/upload-document/UploadDocumentsList.vue')
      }

    ]
  }
]

const routes = [
  {
    path: ':orgType/customer-contact/',
    name: ROUTES.CUSTOMER_CONTACT_LIST,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_customercontact_list'],
      requiresAuth: true
    },
    component: () => import('./CustomerContactList.vue'),
    children: listChildren
  },
  {
    path: ':orgType/customer-contact/',
    name: ROUTES.CUSTOMER_CONTACT_INACTIVE_LIST,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_customercontact_list'],
      requiresAuth: true
    },
    component: () => import('./CustomerContactList.vue'),
    children: listChildren
  }

]

export { routes, ROUTES }
